export default __webpack_public_path__ + "static/media/aero-thermometer.da2c0928.jpg";